module.exports = __webpack_public_path__ + "media/images/ALLCARE_ACADEMY_Banner_1-e270145a8e7020d35620442db4507cac.jpg";